export default "__VITE_ASSET__D3lmxmF9__"